import { observer } from 'mobx-react';
import React from 'react';
import { Tracker } from '@udemy/event-tracking';
import { useI18n } from '@udemy/i18n';
import { CategoryNavItemSelectEvent } from '../../../events';
import { useHeaderStore } from '../../../hooks/use-header-store';
import { useMobileNavStore } from '../../../hooks/use-mobile-nav-store';
import { MobileNavItem, MobileNavL1Nav, MobileNavL2Nav, MobileNavSection } from '../mobile-nav.react-component';
export const MobilePopularTopicNavs = observer(() => {
  var _mobileNavStore$mostP;
  const mobileNavStore = useMobileNavStore();
  const {
    gettext
  } = useI18n();
  const {
    isSplitNavByCategoriesEnabled
  } = useHeaderStore();
  function handleTopicNavClick(subcat, item) {
    const context = {
      categoryId: subcat.parentId,
      subcategoryId: subcat.id,
      topicId: item.id,
      uiRegion: 'mobile_nav'
    };
    Tracker.publishEvent(new CategoryNavItemSelectEvent({
      context
    }));
  }
  const renderSubcategoryElement = subcat => {
    var _subcat$popularTopics;
    const id = `header-toggle-side-nav-popular-topics-of-${subcat.id}`;
    const key = `l1-subcat-id-${subcat.id}`;
    const topicSection = /*#__PURE__*/React.createElement(MobileNavSection, null, (_subcat$popularTopics = subcat.popularTopics) === null || _subcat$popularTopics === void 0 ? void 0 : _subcat$popularTopics.map(topic => /*#__PURE__*/React.createElement(MobileNavItem, {
      onClick: () => handleTopicNavClick(subcat, topic),
      key: `mobile-nav-topic-id-${topic.id}`,
      "data-purpose": "topic-item",
      href: topic.absolute_url || topic.url
    }, topic.title)));
    if (isSplitNavByCategoriesEnabled) {
      return /*#__PURE__*/React.createElement(MobileNavL2Nav, {
        key: key,
        id: id,
        l1NavId: "header-toggle-side-nav-find-courses",
        l1NavTitle: gettext('Find courses')
      }, topicSection);
    }
    return /*#__PURE__*/React.createElement(MobileNavL1Nav, {
      key: key,
      id: id
    }, topicSection);
  };
  return /*#__PURE__*/React.createElement("span", null, (_mobileNavStore$mostP = mobileNavStore.mostPopularSubcategories) === null || _mobileNavStore$mostP === void 0 ? void 0 : _mobileNavStore$mostP.map(subcat => renderSubcategoryElement(subcat)));
});
//# sourceMappingURL=mobile-popular-topic-navs.react-component.js.map